/**
 * Dropdown
 */

import 'bootstrap/js/dist/dropdown';

// Custom
import 'protons';

import $ from 'jquery';

// Module template
import './_dropdown.twig';

// Import custom sass, includes Bootstrap sass
import './_dropdown.scss';

export const name = 'dropdown';

export function disable() {}

export function enable() {}

$('.header-menu a').click(function () {
  window.location = this.href;
});

export default enable;
